import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import Banner from '../../componentes/comuns/Banner';
import Introducao from '../../componentes/comuns/Introducao';
import Servicos from '../../componentes/comuns/Servicos';
import DivisorSecao from '../../componentes/comuns/DivisorSecao';
import PorQueEscolher from '../../componentes/comuns/PorQueEscolher';
import Depoimentos from '../../componentes/comuns/Depoimentos';

const Empresas = () => {
    return (

        <>
            <Header />
            <main>
                <Banner/>
                <Introducao/>
                <Servicos/>
                <DivisorSecao/>
                <PorQueEscolher/>
                <Depoimentos/>
            </main>
            <Footer />
        </>
    );
}

export default Empresas;